/**
 * The hub's gift art, worn by the Rewards Hub rows of the account, user and
 * mobile menus — referenced on its own, so the header does not pull in the
 * hub's whole index (`@/assets/rewards`).
 */
export const NAV_GIFT = new URL('../../../assets/rewards/nav-gift.webp', import.meta.url).href;
